import { Button, Modal } from "antd";
import styled from "styled-components";

export const ModalProtocol = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
  }

  .ant-modal-body {
    gap: 24px;
    display: flex;
    flex-direction: column;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: start;
  flex-direction: column;
  padding-left: 20px;
`;

export const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Items = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0%;
`;

export const Title = styled.h1`
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0%;
`;

export const Infos = styled.h2`
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  color: rgba(49, 65, 88, 1);
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
`;

export const Message = styled.span`
  color: rgba(49, 65, 88, 1);
  font-size: 16px;
  font-weight: 400;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14;
  line-height: 100%;
  letter-spacing: 0%;
  margin-right: 10px;
  @media (max-width: 930px) {
    font-size: 12px;
    padding: 4px 8px;
  }
  @media (max-width: 570px) {
    display: none;
  }
`;

export const Actions = styled.div`
  display: flex;
  gap: 8px;
`;

export const IconButton = styled.button`
  background-color: ${({ active }) =>
    active ? "rgba(6, 142, 195, 1)" : "rgba(241, 245, 249, 1)"};
  border: none;
  width: 42px;
  height: 32px;
  border-radius: 10px;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 1px 2px 0px rgba(25, 25, 28, 0.04);
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

  &:hover {
    transform: scale(1.05);
  }

  svg {
    font-size: 18px;
    color: ${({ active }) =>
      active ? "rgba(255, 255, 255, 1)" : "rgba(194, 194, 204, 1)"};
  }
`;

export const ButtonProtocol = styled(Button)`
  font-family: "Inter", sans-serif;
  border-radius: 10px;
  border: none;
  height: 38px;
  width: 100%;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-shadow: 0px 1px 2px 0px rgba(25, 25, 28, 0.04);
`;
